import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import AdminForm from "../AdminForm";
import { addMeta } from "./metasAdminSlice";

const field = {
  title: "Информация",
  data: [
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Alias",
      name: "alias",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Meta title",
      name: "titleMeta",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Meta tags",
      name: "tagsMeta",
    },
    {
      required: true,
      options: undefined,
      type: "text",
      title: "Meta description",
      name: "descriptionMeta",
    },
  ],
};

const AddComment = () => {
  const dispatch = useDispatch();
  const [progress, setProgress] = useState(0);
  const navigate = useNavigate();
  const onSubmit = (data: any) => {
    console.log(data);
    dispatch(
      addMeta(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };

  return (
    <>
      <p>
        Мета заглавие (дължина): 20 - 60 знака
        <br />
        Мета тагове (брой): 4 - 9 тага
        <br />
        Мета описание (дължина): 50 - 160 знака
      </p>
      <AdminForm formTitle="Добавяне на мета информация" onSubmit={onSubmit} field={field} progress={progress} />
    </>
  );
};

export default AddComment;
